document.addEventListener("DOMContentLoaded", () => {
  const searchOverlay = document.querySelector("[data-rudra-search]");
  const searchOpenButtons = document.querySelectorAll("[data-rudra-search-open]");
  const searchCloseButton = document.querySelector("[data-rudra-search-close]");

  if (!searchOverlay) return;

  const searchInput = searchOverlay.querySelector("[data-rudra-search-input]");
  const searchForm = searchOverlay.querySelector(".rudra-search__form");
  const predictiveSearch = searchOverlay.querySelector("[data-rudra-predictive-search]");
  const popularSearches = searchOverlay.querySelector("[data-rudra-popular-searches]");
  const predictiveSearchUrl = searchOverlay.dataset.predictiveSearchUrl;
  const minQueryLength = 2;
  let searchTimeout = null;
  let activeRequest = null;

  const formatPrice = (product) => {
    if (product.price) return product.price;
    if (product.price_min) return product.price_min;
    return "";
  };

  const getProductImage = (product) => {
    if (product.featured_image && product.featured_image.url) {
      return product.featured_image.url;
    }

    if (product.image && product.image.url) {
      return product.image.url;
    }

    if (typeof product.image === "string") {
      return product.image;
    }

    return "";
  };

  const clearSuggestions = () => {
    if (predictiveSearch) {
      predictiveSearch.innerHTML = "";
      predictiveSearch.classList.remove("is-visible");
    }

    searchOverlay.classList.remove("has-results");
    if (popularSearches) popularSearches.hidden = false;
  };

  const renderMessage = (message) => {
    if (!predictiveSearch) return;

    if (popularSearches) popularSearches.hidden = true;
    searchOverlay.classList.add("has-results");
    searchOverlay.classList.toggle("is-searching", message.indexOf("Finding") === 0);
    predictiveSearch.innerHTML = "";
    const messageElement = document.createElement("p");
    messageElement.className = "rudra-search__message";
    messageElement.setAttribute("role", "status");
    messageElement.textContent = message;
    predictiveSearch.appendChild(messageElement);
    predictiveSearch.classList.add("is-visible");
  };

  const renderProduct = (product) => {
    const link = document.createElement("a");
    link.className = "rudra-search-product";
    link.href = product.url;
    link.setAttribute("role", "option");

    const imageUrl = getProductImage(product);

    if (imageUrl) {
      const image = document.createElement("img");
      image.src = imageUrl;
      image.alt = product.title;
      image.loading = "lazy";
      link.appendChild(image);
    }

    const content = document.createElement("span");
    content.className = "rudra-search-product__content";

    const title = document.createElement("span");
    title.className = "rudra-search-product__title";
    title.textContent = product.title;
    content.appendChild(title);

    const price = formatPrice(product);
    if (price) {
      const priceElement = document.createElement("span");
      priceElement.className = "rudra-search-product__price";
      priceElement.textContent = price;
      content.appendChild(priceElement);
    }

    link.appendChild(content);
    return link;
  };

  const renderSuggestions = (products, query) => {
    if (!predictiveSearch) return;

    if (popularSearches) popularSearches.hidden = true;
    searchOverlay.classList.add("has-results");
    predictiveSearch.innerHTML = "";

    if (!products.length) {
      renderMessage("No watches found. Try a different search.");
      return;
    }

    const heading = document.createElement("p");
    heading.className = "rudra-search__eyebrow";
    heading.textContent = "Suggested watches";
    predictiveSearch.appendChild(heading);

    const list = document.createElement("div");
    list.className = "rudra-search__results";
    list.setAttribute("role", "listbox");
    products.forEach((product) => {
      list.appendChild(renderProduct(product));
    });
    predictiveSearch.appendChild(list);

    const viewAll = document.createElement("a");
    viewAll.className = "rudra-search__view-all";
    viewAll.href = `${searchForm ? searchForm.action : window.location.pathname}?q=${encodeURIComponent(query)}`;
    viewAll.textContent = "View all search results";
    predictiveSearch.appendChild(viewAll);

    predictiveSearch.classList.add("is-visible");
  };

  const fetchSuggestions = async (query) => {
    if (!predictiveSearchUrl) {
      clearSuggestions();
      return;
    }

    if (activeRequest) {
      activeRequest.abort();
    }

    activeRequest = new AbortController();

    const endpoint = new URL(`${predictiveSearchUrl}.json`, window.location.origin);
    endpoint.searchParams.set("q", query);
    endpoint.searchParams.set("resources[type]", "product");
    endpoint.searchParams.set("resources[limit]", "4");
    endpoint.searchParams.set("resources[options][unavailable_products]", "last");
    endpoint.searchParams.set("resources[options][fields]", "title,product_type,variants.title");

    try {
      const response = await fetch(endpoint.toString(), {
        signal: activeRequest.signal,
        headers: {
          Accept: "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Predictive search unavailable");
      }

      const data = await response.json();
      const products = data.resources && data.resources.results ? data.resources.results.products || [] : [];
      renderSuggestions(products, query);
    } catch (error) {
      if (error.name === "AbortError") return;
      renderMessage("Live suggestions are unavailable. Press Search to continue.");
    } finally {
      searchOverlay.classList.remove("is-searching");
      searchOverlay.setAttribute("aria-busy", "false");
    }
  };

  const handleSearchInput = () => {
    if (!searchInput) return;

    const query = searchInput.value.trim();

    window.clearTimeout(searchTimeout);

    if (query.length < minQueryLength) {
      clearSuggestions();
      return;
    }

    searchOverlay.setAttribute("aria-busy", "true");
    renderMessage("Finding Rudra watches...");

    searchTimeout = window.setTimeout(() => {
      fetchSuggestions(query);
    }, 220);
  };

  const openSearch = () => {
    const mobileDrawer = document.querySelector("[data-rudra-mobile-menu]");
    const menuButton = document.querySelector("[data-rudra-menu-button]");

    if (mobileDrawer) {
      mobileDrawer.classList.remove("is-open");
      mobileDrawer.setAttribute("aria-hidden", "true");
    }

    if (menuButton) {
      menuButton.setAttribute("aria-expanded", "false");
    }

    document.body.classList.remove("rudra-drawer-open");
    searchOverlay.classList.add("is-open");
    searchOverlay.setAttribute("aria-hidden", "false");
    searchOverlay.setAttribute("aria-busy", "false");
    document.body.classList.add("rudra-search-open");
    clearSuggestions();

    if (searchInput) {
      window.setTimeout(() => {
        searchInput.focus();
      }, 80);
    }
  };

  const closeSearch = () => {
    searchOverlay.classList.remove("is-open");
    searchOverlay.setAttribute("aria-hidden", "true");
    searchOverlay.setAttribute("aria-busy", "false");
    searchOverlay.classList.remove("is-searching");
    document.body.classList.remove("rudra-search-open");
    clearSuggestions();

    if (searchInput) {
      searchInput.value = "";
    }
  };

  searchOpenButtons.forEach((button) => {
    button.addEventListener("click", openSearch);
  });

  if (searchCloseButton) {
    searchCloseButton.addEventListener("click", closeSearch);
  }

  searchOverlay.addEventListener("click", (event) => {
    if (event.target.hasAttribute("data-rudra-search-close")) {
      closeSearch();
    }
  });

  if (searchInput) {
    searchInput.addEventListener("input", handleSearchInput);
  }

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeSearch();
    }
  });
});
